//#region src/extensions/image-extension/constants/index.ts
var e = "is-mobile-full-width", t = "data-mobile-full-width";
//#endregion
export { e as MOBILE_FULL_WIDTH_CLASSNAME, t as MOBILE_FULL_WIDTH_DATA_ATTRIBUTE };
